import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import registerServiceWorker from './registerServiceWorker';
import createStore from './store/create';
import App from './components/App';

// dea Core components: non-validated/non-progression
export { default as Intro } from './components/Intro';
export { default as Accordion } from './components/Accordion';
export { default as Button } from './components/Button';
export { default as ConfidenceRanking } from './components/ConfidenceRanking';
export { default as ReviewSheet } from './components/ReviewSheet';
export { default as Scoreboard } from './components/Scoreboard';
export { default as Voiceover } from './components/Voiceover';
export { default as ShowWhatYouKnow } from './components/ShowWhatYouKnow';

// dea Core components: validated/progression
export { default as FlipCard } from './components/FlipCards';
export { default as PagerButton } from './components/PagerButton';
export { default as AccordionGroup } from './components/AccordionGroup';
export { default as MultipleChoice } from './components/MultipleChoice';
export { default as ClickAndReveal } from './components/ClickAndReveal';
export { default as ModalCards } from './components/ModalCards';
export { default as SwipeCards } from './components/SwipeCards';
export { default as CompleteSentence } from './components/CompleteSentence';
export { default as Dropdown } from './components/Dropdown';
export { default as DragAndDrop } from './components/DragAndDrop';
export { default as Video } from './components/Video';
export { default as Reorder } from './components/Reorder';
export { default as SliderGroup } from './components/Slider';
export { default as Slideshow } from './components/Slideshow';
export { default as slideTypes } from './components/Slideshow/slideTypes';
export {
  default as slideTextTypes
} from './components/Slideshow/slideTextTypes';
export { default as PersonalityQuiz } from './components/PersonalityQuiz';
export { default as FrontPage } from './components/FrontPage/FrontPage';
export { default as Carousel } from './components/Carousel';
export { default as Calculation } from './components/Calculation';
export { default as SelectObject } from './components/SelectObject';
export { default as WordBankSelect } from './components/WordBankSelect';

export default data => {
  ReactDOM.render(
    <Provider store={createStore()}>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <App data={data} />
      </BrowserRouter>
    </Provider>,
    document.getElementById('root')
  );
  registerServiceWorker();
};



// WEBPACK FOOTER //
// ../core/src/index.js